import { BranchingOperation } from './types'

export const BranchingOperationsDropdown = [
  { title: 'Is', value: BranchingOperation.Is },
  { title: 'Is Empty', value: BranchingOperation.IsEmpty },
  { title: 'Is Not Empty', value: BranchingOperation.IsNotEmpty }
]

export const indentationColors = [
  '#0A3B9E',
  '#005C99',
  '#0079CC',
  '#3399FF',
  '#66B3FF',
  '#99CCFF'
]

export const BRANCHING_TOOLTIP_TITLE = 'Ensure the prompt is filled and there are no duplicate options before enabling branching'
export const DUPLICATE_TOOLTIP_TITLE = 'Please save the question before duplicating it'
